import { render, staticRenderFns } from "./ShButton.vue?vue&type=template&id=0765e586&scoped=true"
import script from "./ShButton.vue?vue&type=script&lang=js"
export * from "./ShButton.vue?vue&type=script&lang=js"
import style0 from "./ShButton.vue?vue&type=style&index=0&id=0765e586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765e586",
  null
  
)

export default component.exports